<template>
  <div>
    <div v-for="(booking, index) in bookings" :key="index">
      <div
        v-if="booking.status == 'completed'"
        class="box is-light wdt mb-4"
        style="width: 600px; max-width: 100%; margin: auto;"
      >
        <div class="has-text-grey is-size-7 has-text-left is-uppercase">
          #{{ booking.bookingKey }}
        </div>

        <div class="is-size-4 mt-2 mb-4 has-text-centered">
          Your Booking Has Been Successfully Completed
        </div>

        <TripCard class="has-text-left" v-if="booking.trip.tripSummary && !pathMixin_isMeeting" :trip="booking.trip" />

        <div v-else class="notification is-success is-light has-text-centered">
          <div v-if="booking.trip.passengers">
            Passenger(s):
            <div
              v-for="(passenger, pIndex) in booking.trip.passengers"
              :key="pIndex"
              style="font-size: 17px;font-weight:bold"
            >
              {{ passenger.firstName }} {{ passenger.lastName }}
            </div>
          </div>

          Reservation number:<br />
          <b class="is-2" style="font-size: 20px;">
            {{ booking.recordLocator }}
          </b>
        </div>

        <p class="has-text-centered">
          Please check your email for more information or
          <a @click="search()"> search more travel </a>
        </p>
      </div>

      <div
        v-else-if="booking.status == 'failed' || booking.status == 'queued'"
        class="box is-light wdt mb-4 has-text-centered"
        style="width: 600px; max-width: 100%; margin: auto;"
      >
        <div class="has-text-grey is-size-7 has-text-left is-uppercase">
          #{{ booking.bookingKey }}
        </div>

        <div class="is-size-4 mt-2 mb-4 has-text-centered">
          Booking Failed
        </div>
        <div class="mb-5 notification is-light is-danger">
          <div v-if="booking.trip">
            <div v-if="booking.trip.passengers">
              Passenger(s):
              <div
                v-for="(passenger, pIndex) in booking.trip.passengers"
                :key="pIndex"
                style="font-size: 17px;font-weight:bold"
                class="has-text-centered"
              >
                {{ passenger.firstName }} {{ passenger.lastName }}
              </div>
            </div>
          </div>

          We encountered an error with your booking and it has not been
          completed. Please try to submit your booking again or contact us using
          one of the methods below to complete your booking.
        </div>
        <p class="mb-2">
          Email Gant's Online Team:
          <a href="mailto:clientservices@ganttravel.com">
            clientservices@ganttravel.com
          </a>
        </p>
        <p class="mb-2">
          Contact Gant Travel directly for agent assistance at 877-924-0303
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import TripCard from "@/components/Trip/TripCard";
export default {
  name: "ConfirmationStatus",
  components: {TripCard},
  props: {
    bookings: Array
  },
  data: function() {
    return {};
  },
  computed: {},
};
</script>

<style></style>
